window.CATALOG = [
  {
    "id": "slider-g",
    "handle": "rund-krystal-halskaede-solv",
    "name": "Slider-Halskette",
    "metal": "gold",
    "family": "slider",
    "variant": "27 cm",
    "price": 74.95,
    "description": "Verstellbarer Slider mit zwei feinen Tropfen. Kostenloser Wechsel zu einer anderen Länge.",
    "material": "18K vergoldeter Edelstahl",
    "size": "27 cm · kostenloser Wechsel zu einer anderen Länge",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/rund-krystal-halskaede-solv-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/rund-krystal-halskaede-solv-1.jpg"
    ],
    "url": "https://lelafine.de/products/rund-krystal-halskaede-solv",
    "builder": true,
    "category": "halskaeder",
    "variantId": "54533167546710",
    "sku": "H-199-SC-18KG-27cm",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_19_guld.png?v=1767460206",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_19_guld.png?v=1767460206",
        "alt": "Slider Halskæde Guldbelagt"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/b2987ddfc5394c8fb7a3fc1bb1296ce0/b2987ddfc5394c8fb7a3fc1bb1296ce0.HD-720p-4.5Mbps-63047568.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/b2987ddfc5394c8fb7a3fc1bb1296ce0.thumbnail.0000000000.jpg?v=1763388360",
        "alt": "no-contrast"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_78.png?v=1787227703",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_78.png?v=1787227703",
        "alt": "Slider Halskæde"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/nyt.png?v=1787232672",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/nyt.png?v=1787232672",
        "alt": "Slider Halskæde"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_64.png?v=1787227825",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_64.png?v=1787227825",
        "alt": "Slider Halskæde"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_91.png?v=1787229083",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_91.png?v=1787229083",
        "alt": "Slider Halskæde"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "alt": "Slider Armbånd Guldbelagt"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/slider_packshot_diagonal_2000.png?v=1787414915",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/slider_packshot_diagonal_2000.png?v=1787414915",
        "alt": "Slider halskæde – diagonalt produktbillede"
      }
    ],
    "productId": "9971886424406",
    "available": true
  },
  {
    "id": "echo-g",
    "handle": "echo-drop",
    "name": "Echo Drop",
    "metal": "gold",
    "family": "echo",
    "variant": "Kristall",
    "price": 89.95,
    "description": "Ein vollständiges Paar Echo Drop mit vier Kristallen – zwei Steine pro Ohr.",
    "material": "18K vergoldet · Zirkonia",
    "size": "Ca. 19 mm · 2 Ohrringe",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/echo-drop-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/echo-drop-2.jpg"
    ],
    "url": "https://lelafine.de/products/echo-drop",
    "builder": true,
    "category": "oreringe",
    "variantId": "54961865523542",
    "sku": "O-401-ED-18KG-CZ",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/echodrop_oplaeg_5.png?v=1790948192",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/echodrop_oplaeg_5.png?v=1790948192",
        "alt": "Echo Drop"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/e333cho-drop-03-rettet-01.png?v=1786867973",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/e333cho-drop-03-rettet-01.png?v=1786867973",
        "alt": "Echo Drop"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/fc83c1171bbf4820830e7c2a7b141653/fc83c1171bbf4820830e7c2a7b141653.HD-720p-4.5Mbps-91377699.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/fc83c1171bbf4820830e7c2a7b141653.thumbnail.0000000000.jpg?v=1786506732",
        "alt": "no-contrast"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/echo-drop-mindre-hul-C-kopi.png?v=1790948300",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/echo-drop-mindre-hul-C-kopi.png?v=1790948300",
        "alt": "Echo Drop"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/exec-45f900cd-b69a-4070-9362-f95ffb3b43ea-kopi.png?v=1786872074",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/exec-45f900cd-b69a-4070-9362-f95ffb3b43ea-kopi.png?v=1786872074",
        "alt": "Echo Drop"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/41242imeeeage.png?v=1786481214",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/41242imeeeage.png?v=1786481214",
        "alt": "Echo Drop"
      }
    ],
    "productId": "11174583501142",
    "available": true
  },
  {
    "id": "stud-g",
    "handle": "solitaire-krystal-stud-guldbelagt",
    "name": "Kristall-Ohrstecker",
    "metal": "gold",
    "family": "stud",
    "variant": "5 mm",
    "price": 44.95,
    "description": "Klassische Kristall-Ohrstecker. Diese Variante ist 5 mm. Ein vollständiges Paar.",
    "material": "Vergoldet · Kristall",
    "size": "5 mm · ein Paar",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-guldbelagt-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-guldbelagt-2.jpg"
    ],
    "url": "https://lelafine.de/products/solitaire-krystal-stud-guldbelagt",
    "builder": true,
    "category": "oreringe",
    "variants": [
      {
        "id": "stud-g-4mm",
        "name": "4 mm",
        "description": "Klassische Kristall-Ohrstecker. Diese Variante ist 4 mm. Ein vollständiges Paar.",
        "size": "4 mm · ein Paar",
        "price": 44.95,
        "images": [
          "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/solitaire-krystal-stud-guldbelagt-ref.jpg?v=1790079971"
        ],
        "variantId": "55461760172374",
        "sku": "O-1003-SOL-18KG-4mm",
        "available": true
      },
      {
        "id": "stud-g-5mm",
        "name": "5 mm",
        "size": "5 mm · ein Paar",
        "price": 52.95,
        "images": [
          "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-guldbelagt-0.jpg",
          "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-guldbelagt-2.jpg"
        ],
        "variantId": "55461760205142",
        "sku": "O-1003-SOL-18KG-5mm",
        "available": true
      }
    ],
    "variantId": "55461760205142",
    "sku": "O-1003-SOL-18KG-5mm",
    "productId": "11293926392150",
    "available": true,
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/solitaire-krystal-stud-guldbelagt-ref.jpg?v=1790079971",
        "alt": "Kristall Stud Packshot"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystal-stud-4mm-echo-mork-hero-guld-2160x2160.png?v=1791016189",
        "alt": "Kristall Stud 4 mm am Modell"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/lelafine-krystal-stud-guld-3-4-5mm-labels-2000x2000.png?v=1790233281",
        "alt": "Kristall Stud Größenvergleich"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystal-stud-4mm-echo-drop-gold.png?v=1790416388",
        "alt": "Kristall Stud und Echo Drop"
      }
    ]
  },
  {
    "id": "flow-g",
    "handle": "flow-ring",
    "name": "Flow Ring",
    "metal": "gold",
    "family": "flow",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Ein verstellbarer Ring mit fließenden Linien.",
    "material": "18K vergoldeter Edelstahl",
    "size": "Verstellbar · ca. 2,5 g",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/flow-ring-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/flow-ring-1.jpg"
    ],
    "url": "https://lelafine.de/products/flow-ring",
    "builder": true,
    "category": "ringe",
    "variantId": "54472803451222",
    "sku": "R-927-F",
    "builderHoldReason": "30-day comparison hold after the 2026-10-02 price increase",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/42142121Ring31_1c5b1a5d-8d5b-47d4-9641-f75b88e61d5a.png?v=1783509768",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/42142121Ring31_1c5b1a5d-8d5b-47d4-9641-f75b88e61d5a.png?v=1783509768",
        "alt": "Flow Ring"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/billede_kvadratisk_2000x2000_b675c4e8-3350-4a82-a6c4-37a0fcba659e.png?v=1783509906",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/billede_kvadratisk_2000x2000_b675c4e8-3350-4a82-a6c4-37a0fcba659e.png?v=1783509906",
        "alt": "Flow Ring"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "alt": "Slider Armbånd Guldbelagt"
      }
    ],
    "productId": "10952403157334",
    "available": true,
    "referencePrice": 34.95
  },
  {
    "id": "slider-s",
    "handle": "justerbar-halskaede-solvbelagt",
    "name": "Slider-Halskette",
    "metal": "silver",
    "family": "slider",
    "variant": "27 cm",
    "price": 74.95,
    "description": "Verstellbarer Slider mit zwei feinen Tropfen. Kostenloser Wechsel zu einer anderen Länge.",
    "material": "Silberfarben finish",
    "size": "27 cm · kostenloser Wechsel zu einer anderen Länge",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/justerbar-halskaede-solvbelagt-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/justerbar-halskaede-solvbelagt-1.jpg"
    ],
    "url": "https://lelafine.de/products/justerbar-halskaede-solvbelagt",
    "builder": true,
    "category": "halskaeder",
    "variantId": "54533487853910",
    "sku": "H-200-SC-925S-27cm",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_19_soelv_1.png?v=1767460273",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_19_soelv_1.png?v=1767460273",
        "alt": "Slider Halskæde Sølvfarvet"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/a237288a421d4e929ad82856cae58e7a/a237288a421d4e929ad82856cae58e7a.HD-720p-4.5Mbps-63051980.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/a237288a421d4e929ad82856cae58e7a.thumbnail.0000000000.jpg?v=1763390880",
        "alt": "no-contrasts"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/6fe3e9d1-7de0-4665-9e6c-ea745364e21c.png?v=1787232971",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/6fe3e9d1-7de0-4665-9e6c-ea745364e21c.png?v=1787232971",
        "alt": "Slider Halskæde"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_92.png?v=1787228944",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_92.png?v=1787228944",
        "alt": "Slider Halskæde"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8054.heic?v=1769791328",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8054.heic?v=1769791328",
        "alt": "Slider Halskæde Sølvfarvet"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "alt": "Slider Armbånd Guldbelagt"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/slider_packshot_diagonal_solv_2000.png?v=1787415696",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/slider_packshot_diagonal_solv_2000.png?v=1787415696",
        "alt": "Slider Halskæde – diagonalt produktbillede i sølv"
      }
    ],
    "productId": "9972180517206",
    "available": true
  },
  {
    "id": "echo-s",
    "handle": "echo-drop-kopi",
    "name": "Echo Drop",
    "metal": "silver",
    "family": "echo",
    "variant": "Kristall",
    "price": 89.95,
    "description": "Ein vollständiges Paar Echo Drop mit vier Kristallen – zwei Steine pro Ohr.",
    "material": "Silberfarben · Zirkonia",
    "size": "Ca. 19 mm · 2 Ohrringe",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/echo-drop-kopi-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/echo-drop-kopi-2.jpg"
    ],
    "url": "https://lelafine.de/products/echo-drop-kopi",
    "builder": true,
    "category": "oreringe",
    "variantId": "55046078169430",
    "sku": "0-402-ED-925s-CZ",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image-1787221482360.png?v=1790709729",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image-1787221482360.png?v=1790709729",
        "alt": "Echo Drop"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/fc83c1171bbf4820830e7c2a7b141653/fc83c1171bbf4820830e7c2a7b141653.HD-720p-4.5Mbps-91377699.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/fc83c1171bbf4820830e7c2a7b141653.thumbnail.0000000000.jpg?v=1786506732",
        "alt": "no-contrast"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/exec-45f900cd-b69a-4070-9362-f95ffb3b43ea-kopi.png?v=1786872074",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/exec-45f900cd-b69a-4070-9362-f95ffb3b43ea-kopi.png?v=1786872074",
        "alt": "Echo Drop"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image-1787221506321.png?v=1790709729",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image-1787221506321.png?v=1790709729",
        "alt": "Echo Drop"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/41242imeeeage.png?v=1786481214",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/41242imeeeage.png?v=1786481214",
        "alt": "Echo Drop"
      }
    ],
    "productId": "11193141920086",
    "available": true
  },
  {
    "id": "stud-s",
    "handle": "solitaire-krystal-stud-solvfarvet",
    "name": "Kristall-Ohrstecker",
    "metal": "silver",
    "family": "stud",
    "variant": "5 mm",
    "price": 52.95,
    "description": "Klassische Kristall-Ohrstecker. Im silberfarbenen Kalender: 5 mm. Ein vollständiges Paar.",
    "material": "Silberfarben · Kristall",
    "size": "5 mm · ein Paar",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-solvfarvet-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-solvfarvet-2.jpg"
    ],
    "url": "https://lelafine.de/products/solitaire-krystal-stud-solvfarvet",
    "builder": true,
    "category": "oreringe",
    "variants": [
      {
        "id": "stud-s-5mm",
        "name": "5 mm",
        "size": "5 mm · ein Paar",
        "price": 52.95,
        "images": [
          "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-solvfarvet-0.jpg",
          "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/solitaire-krystal-stud-solvfarvet-2.jpg"
        ],
        "variantId": "55461761778006",
        "sku": "O-1004-SOL-925S-5mm",
        "available": true
      }
    ],
    "variantId": "55461761778006",
    "sku": "O-1004-SOL-925S-5mm",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/solitaire-krystal-stud-solvfarvet-ref.jpg?v=1790079995",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/solitaire-krystal-stud-solvfarvet-ref.jpg?v=1790079995",
        "alt": "Solitaire Krystal Stud Sølvfarvet"
      },
      {
        "type": "image",
        "src": "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/stud-s-5mm-model.webp",
        "poster": "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/stud-s-5mm-model.webp",
        "alt": "Krystal Stud i 5 mm på model · visualisering"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/lelafine-solitaire-stud-solv-3-4-5mm-labels-2000x2000.png?v=1790233280",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/lelafine-solitaire-stud-solv-3-4-5mm-labels-2000x2000.png?v=1790233280",
        "alt": "Solitaire Krystal Stud Sølvfarvet – 3 mm, 4 mm og 5 mm"
      }
    ],
    "productId": "11293926687062",
    "available": true
  },
  {
    "id": "chunky-s",
    "handle": "chunky-half-stud-solvbelagt",
    "name": "Chunky Half Stud",
    "metal": "silver",
    "family": "chunky",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Markante, weich gerundete Ohrringe mit glänzender Oberfläche. Ein vollständiges Paar.",
    "material": "Hochpolierter Edelstahl",
    "size": "Ca. 9 × 20 mm",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/chunky-half-stud-solvbelagt-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/chunky-half-stud-solvbelagt-1.jpg"
    ],
    "url": "https://lelafine.de/products/chunky-half-stud-solvbelagt",
    "builder": true,
    "category": "oreringe",
    "variantId": "54511522316630",
    "sku": "O-959-CHS-925S",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/d54b0b7c-85a3-42e5-a32f-50b290501015.png?v=1787222172",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/d54b0b7c-85a3-42e5-a32f-50b290501015.png?v=1787222172",
        "alt": "Chunky Half Stud"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Soelv-stud-model-V1-F6F6F6-2000x2000.png?v=1783763157",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Soelv-stud-model-V1-F6F6F6-2000x2000.png?v=1783763157",
        "alt": "Chunky Half Stud Sølvfarvet"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "alt": "Slider Armbånd Guldbelagt"
      }
    ],
    "productId": "10963613057366",
    "available": true
  },
  {
    "id": "chunky-g",
    "handle": "chunky-half-stud",
    "name": "Chunky Half Stud",
    "metal": "gold",
    "family": "chunky",
    "variant": "Default Title",
    "price": 55.95,
    "description": "Markante, weich gerundete Ohrringe mit glänzender Oberfläche. Ein vollständiges Paar.",
    "material": "Goldfarben",
    "size": "Ein Paar Ohrringe",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/chunky-half-stud-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/chunky-half-stud-1.jpg"
    ],
    "url": "https://lelafine.de/products/chunky-half-stud",
    "builder": true,
    "category": "oreringe",
    "variantId": "52745345663318",
    "sku": "O-287-CH-18KG",
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddwchunky-half-hoop1.png?v=1774682451",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddwchunky-half-hoop1.png?v=1774682451",
        "alt": "Chunky Half Stud Guldbelagt"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ffhf_20260328_141516_716d0482-d71c-46a9-b436-cdf30c1d67851.png?v=1774707622",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ffhf_20260328_141516_716d0482-d71c-46a9-b436-cdf30c1d67851.png?v=1774707622",
        "alt": "Chunky Half Stud Guldbelagt"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_78_b29dcdcd-8ec2-471d-b62e-72226650f29b.png?v=1787229379",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/image_78_b29dcdcd-8ec2-471d-b62e-72226650f29b.png?v=1787229379",
        "alt": "Chunky Half Stud"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "alt": "Slider Armbånd Guldbelagt"
      }
    ],
    "productId": "10242668462422",
    "available": true
  },
  {
    "id": "crystal14-s",
    "handle": "krystal-oreringe-solvbelagt-14mm",
    "name": "Runde Kristallohrringe",
    "metal": "silver",
    "family": "crystal14",
    "category": "oreringe",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Entdecke alle Details und die passende Größe in der Bildergalerie und auf der Produktseite.",
    "material": "925 Sterlingsilber",
    "size": "14 mm Innendurchmesser · ca. 2 mm Stärke · ein Paar",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/crystal14-s-v3-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/crystal14-s-v3-1.jpg"
    ],
    "url": "https://lelafine.de/products/krystal-oreringe-solvbelagt-14mm",
    "builder": true,
    "variantId": "54799961325910",
    "sku": "O-960-K1-925S",
    "productId": "11140086628694",
    "available": true
  },
  {
    "id": "slider-bracelet-g",
    "handle": "slider-armband-guldbelagt",
    "name": "Slider-Armband",
    "metal": "gold",
    "family": "slider-bracelet",
    "category": "armband",
    "variant": "Länge wählen",
    "price": 44.95,
    "description": "Entdecke alle Details und die passende Größe in der Bildergalerie und auf der Produktseite.",
    "material": "Goldfarben Edelstahl · e-coating",
    "size": "Länge wählen · 4 cm Verlängerung",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/slider-armband-guldbelagt-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/slider-armband-guldbelagt-1.jpg"
    ],
    "url": "https://lelafine.de/products/slider-armband-guldbelagt",
    "builder": true,
    "needsSize": true,
    "variants": [
      {
        "id": "slider-bracelet-g--0",
        "name": "15,5 cm",
        "size": "15,5 cm + 4 cm Verlängerung",
        "shopifyVariantId": "gid://shopify/ProductVariant/54786849440086",
        "variantId": "54786849440086",
        "sku": "A-152-S-18KG-15cm",
        "price": 44.95,
        "available": true
      },
      {
        "id": "slider-bracelet-g--1",
        "name": "18 cm",
        "size": "18 cm + 4 cm Verlängerung",
        "shopifyVariantId": "gid://shopify/ProductVariant/54992296182102",
        "variantId": "54992296182102",
        "sku": "A-152-S-18KG-18cm",
        "price": 44.95,
        "available": true
      }
    ],
    "productId": "11137245905238",
    "variantId": "54786849440086",
    "available": true,
    "sku": "A-152-S-18KG-15cm"
  },
  {
    "id": "slider-bracelet-s",
    "handle": "slider-armband-solvfarvet",
    "name": "Slider-Armband",
    "metal": "silver",
    "family": "slider-bracelet",
    "category": "armband",
    "variant": "Länge wählen",
    "price": 44.95,
    "description": "Entdecke alle Details und die passende Größe in der Bildergalerie und auf der Produktseite.",
    "material": "Silberfarben Edelstahl · e-coating",
    "size": "Länge wählen · 4 cm Verlängerung",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/slider-armband-solvfarvet-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/slider-armband-solvfarvet-1.jpg"
    ],
    "url": "https://lelafine.de/products/slider-armband-solvfarvet",
    "builder": true,
    "needsSize": true,
    "variants": [
      {
        "id": "slider-bracelet-s--0",
        "name": "15,5 cm",
        "size": "15,5 cm + 4 cm Verlängerung",
        "shopifyVariantId": "gid://shopify/ProductVariant/54786025357654",
        "variantId": "54786025357654",
        "sku": "A-150-S-925S-15cm",
        "price": 44.95,
        "available": true
      },
      {
        "id": "slider-bracelet-s--1",
        "name": "18 cm",
        "size": "18 cm + 4 cm Verlängerung",
        "shopifyVariantId": "gid://shopify/ProductVariant/54992295821654",
        "variantId": "54992295821654",
        "sku": "A-150-S-925S-18cm",
        "price": 44.95,
        "available": true
      }
    ],
    "productId": "11137023967574",
    "variantId": "54786025357654",
    "available": true,
    "sku": "A-150-S-925S-15cm"
  },
  {
    "id": "crystal14-g",
    "handle": "krystal-creoler-18k-guldbelagt-14mm",
    "name": "Runde Kristallohrringe",
    "metal": "gold",
    "family": "crystal14",
    "category": "oreringe",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Entdecke alle Details und die passende Größe in der Bildergalerie und auf der Produktseite.",
    "material": "18K vergoldet",
    "size": "14 mm diameter · ein Paar",
    "images": [
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/crystal14-g-0.jpg",
      "https://lelafine-advent-2026-preview.pkmedier.chatgpt.site/assets/crystal14-g-1.jpg"
    ],
    "url": "https://lelafine.de/products/krystal-creoler-18k-guldbelagt-14mm",
    "builder": true,
    "variantId": "51081326821718",
    "sku": "O-251-KC-18KG",
    "productId": "9764662083926",
    "available": true
  },
  {
    "id": "curved-g",
    "handle": "curved-bar-oreringe-14k-guldbelagt",
    "productId": "9147696218454",
    "name": "Curved Bar Ohrringe",
    "metal": "gold",
    "family": "curved",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Geschwungene Ohrringe. Ca. 32 mm lang.",
    "material": "Vergoldet",
    "size": "Ca. 32 mm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/curvedbarguldbelagt.jpg?v=1750320219",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rhf_20260213_082822_39efc43b-14b9-4eb5-9c81-4884b2244b391.png?v=1770972658",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/curvedbarguldbelagt.jpg?v=1750320219",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/curvedbarguldbelagt.jpg?v=1750320219"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rhf_20260213_082822_39efc43b-14b9-4eb5-9c81-4884b2244b391.png?v=1770972658",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rhf_20260213_082822_39efc43b-14b9-4eb5-9c81-4884b2244b391.png?v=1770972658"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
      }
    ],
    "url": "https://lelafine.de/products/curved-bar-oreringe-14k-guldbelagt",
    "builder": true,
    "category": "oreringe",
    "variantId": "48754579308886",
    "sku": "O-178-CB-14KG",
    "available": true
  },
  {
    "id": "blue-heart-g",
    "handle": "blaat-hjerte-stud",
    "productId": "9514197811542",
    "name": "Blaue Herz-Ohrstecker",
    "metal": "gold",
    "family": "blue-heart",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Herzförmige Ohrstecker. Ca. 15 × 9 mm.",
    "material": "Vergoldet",
    "size": "Ca. 15 × 9 mm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/233replicate-prediction-zf7gbmrdr1rme0cv3jsbnyqwe01.png?v=1765713678",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Blaathjertestud.jpg?v=1765713678",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_0013_optimized.jpg?v=1765713678",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_9989_jpg_optimized.jpg?v=1765713678",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/blaathjerte_DSC88851.png?v=1765713678",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_9998_optimized.jpg?v=1765713678"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/233replicate-prediction-zf7gbmrdr1rme0cv3jsbnyqwe01.png?v=1765713678",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/233replicate-prediction-zf7gbmrdr1rme0cv3jsbnyqwe01.png?v=1765713678"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Blaathjertestud.jpg?v=1765713678",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Blaathjertestud.jpg?v=1765713678"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/ff3c53b1bb014d10bd3c24cb32fae89c/ff3c53b1bb014d10bd3c24cb32fae89c.HD-720p-4.5Mbps-50966982.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/ff3c53b1bb014d10bd3c24cb32fae89c.thumbnail.0000000000.jpg?v=1752136013"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_0013_optimized.jpg?v=1765713678",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_0013_optimized.jpg?v=1765713678"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_9989_jpg_optimized.jpg?v=1765713678",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_9989_jpg_optimized.jpg?v=1765713678"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/blaathjerte_DSC88851.png?v=1765713678",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/blaathjerte_DSC88851.png?v=1765713678"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_9998_optimized.jpg?v=1765713678",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/img_9998_optimized.jpg?v=1765713678"
      }
    ],
    "url": "https://lelafine.de/products/blaat-hjerte-stud",
    "builder": true,
    "category": "oreringe",
    "variantId": "50027947917654",
    "sku": "O-113-LS-18KG",
    "available": true
  },
  {
    "id": "classic12-g",
    "handle": "classic-hoop-12-mm",
    "productId": "9605636620630",
    "name": "Classic Hoop · 12 mm",
    "metal": "gold",
    "family": "classic12",
    "variant": "Default Title",
    "price": 31.95,
    "description": "Schlichte goldfarbene Creolen für jeden Tag.",
    "material": "Vergoldet",
    "size": "Ein Paar",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classic-41_1.png?v=1770985286",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystaloerering.png?v=1772018200",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/12-14clas_69752212-644d-428e-856c-146bb46019e7.png?v=1772198648",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classic-41_1.png?v=1770985286",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classic-41_1.png?v=1770985286"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystaloerering.png?v=1772018200",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystaloerering.png?v=1772018200"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/12-14clas_69752212-644d-428e-856c-146bb46019e7.png?v=1772198648",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/12-14clas_69752212-644d-428e-856c-146bb46019e7.png?v=1772198648"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555"
      }
    ],
    "url": "https://lelafine.de/products/classic-hoop-12-mm",
    "builder": true,
    "category": "oreringe",
    "variantId": "50384920969558",
    "sku": "O-203-WH-18KG",
    "available": true
  },
  {
    "id": "crystal16-g",
    "handle": "krystal-creoler-18k-guldbelagt-16mm",
    "productId": "9764670505302",
    "name": "Kristall-Creolen · 16 mm",
    "metal": "gold",
    "family": "crystal16",
    "variant": "Default Title",
    "price": 46.95,
    "description": "Kleine Creolen mit funkelnden Kristallen.",
    "material": "Vergoldet",
    "size": "Ein Paar",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/final42142121image12.png?v=1781643188",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystaloerering.png?v=1772018200",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/16-18_8bbed128-7738-40ff-ad1c-e2b9858a34db.png?v=1772018200",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/final42142121image12.png?v=1781643188",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/final42142121image12.png?v=1781643188"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystaloerering.png?v=1772018200",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/krystaloerering.png?v=1772018200"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/16-18_8bbed128-7738-40ff-ad1c-e2b9858a34db.png?v=1772018200",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/16-18_8bbed128-7738-40ff-ad1c-e2b9858a34db.png?v=1772018200"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555"
      }
    ],
    "url": "https://lelafine.de/products/krystal-creoler-18k-guldbelagt-16mm",
    "builder": true,
    "category": "oreringe",
    "variantId": "51081358606678",
    "sku": "O-252-KC-18KG",
    "available": true
  },
  {
    "id": "mercury-g",
    "handle": "mercury-broche-guldbelagt",
    "productId": "10294859891030",
    "name": "Mercury Brosche",
    "metal": "gold",
    "family": "mercury",
    "variant": "Default Title",
    "price": 74.95,
    "description": "Eine skulpturale Brosche für Blazer, Strick oder Schal.",
    "material": "Vergoldet",
    "size": "Ein Schmuckstück",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddfesesesimage.png?v=1779389790",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/feseimage_09e9840e-3965-4460-9fc3-b41af1b2a499.png?v=1789057247",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fweweewimage_4ac71154-b8d6-476f-a737-0fb01ab831db.png?v=1789057247",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/r33sfimage_aecd1459-0ac5-4b6a-a97a-6575210597bc.png?v=1789057248",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/3wwwwwwimage.png?v=1779025072"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddfesesesimage.png?v=1779389790",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddfesesesimage.png?v=1779389790"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/b349df32599a43eb9d430dc8290c64b3/b349df32599a43eb9d430dc8290c64b3.HD-720p-3.0Mbps-94030971.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/b349df32599a43eb9d430dc8290c64b3.thumbnail.0000000000.jpg?v=1789051667"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/feseimage_09e9840e-3965-4460-9fc3-b41af1b2a499.png?v=1789057247",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/feseimage_09e9840e-3965-4460-9fc3-b41af1b2a499.png?v=1789057247"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fweweewimage_4ac71154-b8d6-476f-a737-0fb01ab831db.png?v=1789057247",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fweweewimage_4ac71154-b8d6-476f-a737-0fb01ab831db.png?v=1789057247"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/r33sfimage_aecd1459-0ac5-4b6a-a97a-6575210597bc.png?v=1789057248",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/r33sfimage_aecd1459-0ac5-4b6a-a97a-6575210597bc.png?v=1789057248"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/3wwwwwwimage.png?v=1779025072",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/3wwwwwwimage.png?v=1779025072"
      }
    ],
    "url": "https://lelafine.de/products/mercury-broche-guldbelagt",
    "builder": true,
    "category": "brocher",
    "variantId": "52941222838614",
    "sku": "B-100-CB-18K",
    "available": true
  },
  {
    "id": "mercury-s",
    "handle": "mercury-broche-solv",
    "productId": "10294911107414",
    "name": "Mercury Brosche",
    "metal": "silver",
    "family": "mercury",
    "variant": "Default Title",
    "price": 74.95,
    "description": "Eine skulpturale Brosche für Blazer, Strick oder Schal.",
    "material": "Silberfarben",
    "size": "Ein Schmuckstück",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fefffssaimage11_1.png?v=1779387953",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddeimage1.png?v=1779387428",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-01-cardigan.png?v=1789057213",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-02-skjorte.png?v=1789057213",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-03-sort-top.png?v=1789057213"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fefffssaimage11_1.png?v=1779387953",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fefffssaimage11_1.png?v=1779387953"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddeimage1.png?v=1779387428",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddeimage1.png?v=1779387428"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-01-cardigan.png?v=1789057213",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-01-cardigan.png?v=1789057213"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-02-skjorte.png?v=1789057213",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-02-skjorte.png?v=1789057213"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-03-sort-top.png?v=1789057213",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mercury-broche-soelv-03-sort-top.png?v=1789057213"
      }
    ],
    "url": "https://lelafine.de/products/mercury-broche-solv",
    "builder": true,
    "category": "brocher",
    "variantId": "52941371670870",
    "sku": "B-101-CB-925",
    "available": true
  },
  {
    "id": "tennis-g",
    "handle": "tennis-krystal-armband-18k-guldbelagt-2mm",
    "productId": "10348699844950",
    "name": "Tennis-Kristallarmband · 2 mm",
    "metal": "gold",
    "family": "tennis",
    "variant": "17 cm",
    "price": 59.95,
    "description": "Feine Kristalle rund ums Handgelenk. Bitte wähle die passende Länge.",
    "material": "Vergoldet",
    "size": "17 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrrfeesseimage1_3.png?v=1776712536",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/feeimage.png?v=1776712536",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eeeimage.png?v=1776794958",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrrfeesseimage1_3.png?v=1776712536",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrrfeesseimage1_3.png?v=1776712536"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/feeimage.png?v=1776712536",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/feeimage.png?v=1776712536"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/bdddd39665d44a0e958fb96eebdd76ca/bdddd39665d44a0e958fb96eebdd76ca.HD-720p-4.5Mbps-82224918.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/bdddd39665d44a0e958fb96eebdd76ca.thumbnail.0000000000.jpg?v=1776794333"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/94e6808adfeb44bcb9410051a5f26bec/94e6808adfeb44bcb9410051a5f26bec.HD-720p-4.5Mbps-82225403.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/94e6808adfeb44bcb9410051a5f26bec.thumbnail.0000000000.jpg?v=1776794913"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eeeimage.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eeeimage.png?v=1776794958"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
      }
    ],
    "url": "https://lelafine.de/products/tennis-krystal-armband-18k-guldbelagt-2mm",
    "builder": true,
    "category": "armband",
    "variantId": "53176156914006",
    "sku": "A-117-HB-925S-17cm",
    "available": true,
    "needsSize": true,
    "variants": [
      {
        "id": "tennis-g-17cm",
        "name": "17 cm",
        "size": "17 cm",
        "variantId": "53176156914006",
        "sku": "A-117-HB-925S-17cm",
        "price": 59.95,
        "available": true
      },
      {
        "id": "tennis-g-18cm",
        "name": "18 cm",
        "size": "18 cm",
        "variantId": "53176156946774",
        "sku": "A-117-HB-925S-18cm",
        "price": 59.95,
        "available": true
      },
      {
        "id": "tennis-g-19cm",
        "name": "19 cm",
        "size": "19 cm",
        "variantId": "53176156979542",
        "sku": "A-117-HB-925S-19cm",
        "price": 59.95,
        "available": true
      }
    ]
  },
  {
    "id": "slider-bracelet-mix",
    "handle": "slider-armband-mix",
    "name": "Slider-Armband",
    "metal": "mixed",
    "family": "slider-bracelet",
    "category": "armband",
    "variant": "Länge wählen",
    "price": 44.95,
    "description": "Zwei Ketten in gold- und silberfarbener Optik mit einem polierten Kugeldetail. Länge wählen.",
    "material": "Gold- und silberfarbene Optik",
    "size": "Länge wählen · 4 cm Verlängerung",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mixguldogsoelvslider.png?v=1784798738",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/model_billede_af_mix_slider_armbaand.png?v=1784798747",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mixguldogsoelvslider.png?v=1784798738",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/mixguldogsoelvslider.png?v=1784798738",
        "alt": "Slider-Armband gemischt"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/model_billede_af_mix_slider_armbaand.png?v=1784798747",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/model_billede_af_mix_slider_armbaand.png?v=1784798747",
        "alt": "Slider-Armband gemischt"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "alt": "Slider-Armband gemischt"
      }
    ],
    "url": "https://lelafine.de/products/slider-armband-mix",
    "builder": true,
    "needsSize": true,
    "variants": [
      {
        "id": "slider-bracelet-mix--0",
        "name": "15,5 cm",
        "size": "15,5 cm + 4 cm Verlängerung",
        "shopifyVariantId": "gid://shopify/ProductVariant/54786185167190",
        "variantId": "54786185167190",
        "sku": "A-151-SM-15cm",
        "price": 44.95
      },
      {
        "id": "slider-bracelet-mix--1",
        "name": "18 cm",
        "size": "18 cm + 4 cm Verlängerung",
        "shopifyVariantId": "gid://shopify/ProductVariant/54992296018262",
        "variantId": "54992296018262",
        "sku": "A-151-SM-18cm",
        "price": 44.95
      }
    ],
    "productId": "11137116504406"
  },
  {
    "id": "mini-chunky-g",
    "handle": "mini-chunky-hoops-18k-guldbelagt",
    "productId": "9230540800342",
    "name": "Dicke Creolen · 12 mm",
    "metal": "gold",
    "family": "mini-chunky",
    "variant": "Default Title",
    "price": 44.95,
    "description": "Ein dezentes, klassisches Creolen-Paar mit runder, glatter Form.",
    "material": "Edelstahl, 18 Karat vergoldet · PVD-Beschichtung",
    "size": "12 mm · ein Paar",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/chunkyguldbelagtehoops_a39b928a-1d94-48a0-9d8c-bb81b85e935a.png?v=1771171249",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2374.jpg?v=1771171249",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2345.jpg?v=1771171249",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_182_1.png?v=1771171249"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/chunkyguldbelagtehoops_a39b928a-1d94-48a0-9d8c-bb81b85e935a.png?v=1771171249",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/chunkyguldbelagtehoops_a39b928a-1d94-48a0-9d8c-bb81b85e935a.png?v=1771171249",
        "alt": "Dicke Creolen 12 mm vergoldet"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2374.jpg?v=1771171249",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2374.jpg?v=1771171249",
        "alt": "Dicke Creolen 12 mm vergoldet"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2345.jpg?v=1771171249",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2345.jpg?v=1771171249",
        "alt": "Dicke Creolen 12 mm vergoldet"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_182_1.png?v=1771171249",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_182_1.png?v=1771171249",
        "alt": "Dicke Creolen 12 mm vergoldet"
      }
    ],
    "url": "https://lelafine.de/products/mini-chunky-hoops-18k-guldbelagt",
    "builder": true,
    "category": "oreringe",
    "variantId": "49023471452502",
    "sku": "O-188-MC-18KG",
    "available": true
  },
  {
    "id": "snake-necklace-g",
    "handle": "flad-slange-halskaede-18k-guldbelagt-4mm",
    "productId": "9107796263254",
    "name": "Flache Schlangenkette 4mm vergoldet",
    "metal": "gold",
    "family": "snake-necklace",
    "variant": "40 cm",
    "price": 44.95,
    "description": "",
    "material": "Vergoldet",
    "size": "40 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fladslangehalskaedeguldbelagt.png?v=1750318794",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/replicate-prediction-v780v42e9nrmt0cvbc9adrk9fw.png?v=1766760068",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/snakebundle1_e042ac7a-e78e-407c-85dc-40daba0cf86a.png?v=1766760068",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3600_2_fa909bb4-1367-4998-b6dd-570870d76390.jpg?v=1766760068"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fladslangehalskaedeguldbelagt.png?v=1750318794",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fladslangehalskaedeguldbelagt.png?v=1750318794"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/replicate-prediction-v780v42e9nrmt0cvbc9adrk9fw.png?v=1766760068",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/replicate-prediction-v780v42e9nrmt0cvbc9adrk9fw.png?v=1766760068"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/snakebundle1_e042ac7a-e78e-407c-85dc-40daba0cf86a.png?v=1766760068",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/snakebundle1_e042ac7a-e78e-407c-85dc-40daba0cf86a.png?v=1766760068"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3600_2_fa909bb4-1367-4998-b6dd-570870d76390.jpg?v=1766760068",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3600_2_fa909bb4-1367-4998-b6dd-570870d76390.jpg?v=1766760068"
      }
    ],
    "url": "https://lelafine.de/products/flad-slange-halskaede-18k-guldbelagt-4mm",
    "builder": true,
    "category": "halskaeder",
    "variantId": "48754211062102",
    "sku": "H-109-FS-18KG-4MM",
    "available": true,
    "variants": [
      {
        "id": "snake-necklace-g-40cm",
        "name": "40 cm",
        "size": "40 cm",
        "variantId": "48754211062102",
        "sku": "H-109-FS-18KG-4MM",
        "variant": "40 cm",
        "price": 44.95,
        "available": true
      },
      {
        "id": "snake-necklace-g-45cm",
        "name": "45 cm",
        "size": "45 cm",
        "variantId": "55044676485462",
        "sku": "H-109-FS-18KG-4MM-45cm",
        "variant": "45 cm",
        "price": 44.95,
        "available": true
      }
    ]
  },
  {
    "id": "snake-bracelet-g",
    "handle": "flad-slange-armband-18k-guldbelagt",
    "productId": "9107901776214",
    "name": "Flaches Schlangenarmband 4mm vergoldet",
    "metal": "gold",
    "family": "snake-bracelet",
    "variant": "15 cm",
    "price": 37.95,
    "description": "",
    "material": "Vergoldet",
    "size": "15 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame298_4.png?v=1754478364",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/armbaandmerefarve2.png?v=1755098352",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/snakebundle1_c0ba0301-fb88-4890-aab3-bd22db62b05c.png?v=1755348994",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2073_1.jpg?v=1756365854"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame298_4.png?v=1754478364",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame298_4.png?v=1754478364"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/armbaandmerefarve2.png?v=1755098352",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/armbaandmerefarve2.png?v=1755098352"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/snakebundle1_c0ba0301-fb88-4890-aab3-bd22db62b05c.png?v=1755348994",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/snakebundle1_c0ba0301-fb88-4890-aab3-bd22db62b05c.png?v=1755348994"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2073_1.jpg?v=1756365854",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2073_1.jpg?v=1756365854"
      }
    ],
    "url": "https://lelafine.de/products/flad-slange-armband-18k-guldbelagt",
    "builder": true,
    "category": "armband",
    "variantId": "48649335931222",
    "sku": "A-104-FS-18KG",
    "available": true,
    "variants": [
      {
        "id": "snake-bracelet-g-15cm",
        "name": "15 cm",
        "size": "15 cm",
        "variantId": "48649335931222",
        "sku": "A-104-FS-18KG",
        "variant": "15 cm",
        "price": 37.95,
        "available": true
      },
      {
        "id": "snake-bracelet-g-18cm",
        "name": "18 cm",
        "size": "18 cm",
        "variantId": "55044676616534",
        "sku": "A-104-FS-18KG-18cm",
        "variant": "18 cm",
        "price": 37.95,
        "available": true
      }
    ]
  },
  {
    "id": "sun-g",
    "handle": "sun-halskaede-18k-guldbelagt",
    "productId": "9107909607766",
    "name": "Sun Halskette vergoldet",
    "metal": "gold",
    "family": "sun",
    "variant": "",
    "price": 44.95,
    "description": "",
    "material": "Vergoldet",
    "size": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunhalskaedeguldbelagt.jpg?v=1750317815",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunfirkantetdistance3_9e91abe5-9b8d-4694-a062-88fed1ddb456.png?v=1757672636",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunsolhalskaede.png?v=1757672636",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2491_1.jpg?v=1765870313"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunhalskaedeguldbelagt.jpg?v=1750317815",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunhalskaedeguldbelagt.jpg?v=1750317815"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunfirkantetdistance3_9e91abe5-9b8d-4694-a062-88fed1ddb456.png?v=1757672636",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunfirkantetdistance3_9e91abe5-9b8d-4694-a062-88fed1ddb456.png?v=1757672636"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunsolhalskaede.png?v=1757672636",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sunsolhalskaede.png?v=1757672636"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2491_1.jpg?v=1765870313",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2491_1.jpg?v=1765870313"
      }
    ],
    "url": "https://lelafine.de/products/sun-halskaede-18k-guldbelagt",
    "builder": true,
    "category": "halskaeder",
    "variantId": "48649368273238",
    "sku": "H-147-SH-18KG",
    "available": true
  },
  {
    "id": "snake-necklace-s",
    "handle": "flad-slange-halskaede-925-solvbelagt-4mm",
    "productId": "9120506839382",
    "name": "Flache Schlangenkette 4mm silberplattiert",
    "metal": "silver",
    "family": "snake-necklace",
    "variant": "40 cm",
    "price": 41.95,
    "description": "",
    "material": "Versilbert",
    "size": "40 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fladslangehalskaedeguldbelagt_eed4606a-de16-4a56-a476-3357f10b64a9.png?v=1754910737",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9067_2_Stor.jpg?v=1754910737",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_269_1.png?v=1754910737",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9103_2_Stor.jpg?v=1754910737"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fladslangehalskaedeguldbelagt_eed4606a-de16-4a56-a476-3357f10b64a9.png?v=1754910737",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/fladslangehalskaedeguldbelagt_eed4606a-de16-4a56-a476-3357f10b64a9.png?v=1754910737"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9067_2_Stor.jpg?v=1754910737",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9067_2_Stor.jpg?v=1754910737"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_269_1.png?v=1754910737",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_269_1.png?v=1754910737"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9103_2_Stor.jpg?v=1754910737",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9103_2_Stor.jpg?v=1754910737"
      }
    ],
    "url": "https://lelafine.de/products/flad-slange-halskaede-925-solvbelagt-4mm",
    "builder": true,
    "category": "halskaeder",
    "variantId": "48680006484310",
    "sku": "H-110-FS-925S-4MM",
    "available": true,
    "variants": [
      {
        "id": "snake-necklace-s-40cm",
        "name": "40 cm",
        "size": "40 cm",
        "variantId": "48680006484310",
        "sku": "H-110-FS-925S-4MM",
        "variant": "40 cm",
        "price": 41.95,
        "available": true
      },
      {
        "id": "snake-necklace-s-45cm",
        "name": "45 cm",
        "size": "45 cm",
        "variantId": "55044676583766",
        "sku": "H-110-FS-925S-4MM-45cm",
        "variant": "45 cm",
        "price": 41.95,
        "available": true
      }
    ]
  },
  {
    "id": "curved-s",
    "handle": "curved-bar-oreringe-925-solv",
    "productId": "9151581258070",
    "name": "Curve Bar",
    "metal": "silver",
    "family": "curved",
    "variant": "",
    "price": 44.95,
    "description": "Geschwungene Ohrringe. Ca. 32 mm lang.",
    "material": "Silberfarben",
    "size": "Ca. 32 mm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/curved_oereringe.webp?v=1785327261",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ddhf_20260213_084858_ea61761f-1348-4280-a033-c5ac004d6ea01.png?v=1770972865",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/curved_oereringe.webp?v=1785327261",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/curved_oereringe.webp?v=1785327261"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ddhf_20260213_084858_ea61761f-1348-4280-a033-c5ac004d6ea01.png?v=1770972865",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ddhf_20260213_084858_ea61761f-1348-4280-a033-c5ac004d6ea01.png?v=1770972865"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/boks01-finalbackground-zoomout1_1.png?v=1776794958"
      }
    ],
    "url": "https://lelafine.de/products/curved-bar-oreringe-925-solv",
    "builder": true,
    "category": "oreringe",
    "variantId": "48767149736278",
    "sku": "O-133-CB-925S",
    "available": true
  },
  {
    "id": "dangle-pearl-g",
    "handle": "dangle-perle-kaedeorering-18k-guldbelagt",
    "productId": "9230526251350",
    "name": "Hängende Perlen Ohrringe Vergoldet",
    "metal": "gold",
    "family": "dangle-pearl",
    "variant": "",
    "price": 56.95,
    "description": "Hängende Ohrringe mit Süßwasserperlen. 4 cm lang.",
    "material": "Vergoldet",
    "size": "4 cm · ein Paar",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Dangle_Perle_oreringe_guldbelagt.webp?v=1750316876",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3522.jpg?v=1750156964",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrreplicate-prediction-ec3jgw7sh1rmc0cv3rmv1x27641.png?v=1765738024",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3743_jpg_e89d17b6-924e-4db5-9118-a182aaec6784.jpg?v=1765738024"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Dangle_Perle_oreringe_guldbelagt.webp?v=1750316876",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Dangle_Perle_oreringe_guldbelagt.webp?v=1750316876"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3522.jpg?v=1750156964",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3522.jpg?v=1750156964"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrreplicate-prediction-ec3jgw7sh1rmc0cv3rmv1x27641.png?v=1765738024",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrreplicate-prediction-ec3jgw7sh1rmc0cv3rmv1x27641.png?v=1765738024"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3743_jpg_e89d17b6-924e-4db5-9118-a182aaec6784.jpg?v=1765738024",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_3743_jpg_e89d17b6-924e-4db5-9118-a182aaec6784.jpg?v=1765738024"
      }
    ],
    "url": "https://lelafine.de/products/dangle-perle-kaedeorering-18k-guldbelagt",
    "builder": true,
    "category": "oreringe",
    "variantId": "49023412928854",
    "sku": "O-186-DP-18KG",
    "available": true
  },
  {
    "id": "dangle-pearl-s",
    "handle": "dangle-perle-kaedeorering-925-solv",
    "productId": "9230531723606",
    "name": "Hängende Perlen Ohrringe Silber",
    "metal": "silver",
    "family": "dangle-pearl",
    "variant": "",
    "price": 56.95,
    "description": "Hängende Ohrringe mit Süßwasserperlen. 4 cm lang.",
    "material": "Silberfarben",
    "size": "4 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Dangle_Perle_Orering_Solv.jpg?v=1750157354",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/danglesoelvperle2.png?v=1765897425",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9177_1.jpg?v=1756796864",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddreplicate-prediction-kjqh6tvyxdrmc0cv448v18edkr1.png?v=1765788178"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Dangle_Perle_Orering_Solv.jpg?v=1750157354",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Dangle_Perle_Orering_Solv.jpg?v=1750157354"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/danglesoelvperle2.png?v=1765897425",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/danglesoelvperle2.png?v=1765897425"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9177_1.jpg?v=1756796864",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_9177_1.jpg?v=1756796864"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddreplicate-prediction-kjqh6tvyxdrmc0cv448v18edkr1.png?v=1765788178",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/dddreplicate-prediction-kjqh6tvyxdrmc0cv448v18edkr1.png?v=1765788178"
      }
    ],
    "url": "https://lelafine.de/products/dangle-perle-kaedeorering-925-solv",
    "builder": true,
    "category": "oreringe",
    "variantId": "49023439864150",
    "sku": "O-187-DPK-925S",
    "available": true
  },
  {
    "id": "sun-s",
    "handle": "sun-halskaede-925-solvbelagt",
    "productId": "9236504576342",
    "name": "Sun Halskette Silberbeschichtet",
    "metal": "silver",
    "family": "sun",
    "variant": "",
    "price": 59.95,
    "description": "",
    "material": "Versilbert",
    "size": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sun_halskaede_solvbelagt.png?v=1750143589",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_270_1.png?v=1765870358",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/meltedsoelv_1_1.png?v=1753982530",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrrreplicate-prediction-gen270eeexrm80cv445t53wjh81.png?v=1765788004"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sun_halskaede_solvbelagt.png?v=1750143589",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Sun_halskaede_solvbelagt.png?v=1750143589"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_270_1.png?v=1765870358",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame_270_1.png?v=1765870358"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/meltedsoelv_1_1.png?v=1753982530",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/meltedsoelv_1_1.png?v=1753982530"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrrreplicate-prediction-gen270eeexrm80cv445t53wjh81.png?v=1765788004",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/rrrreplicate-prediction-gen270eeexrm80cv445t53wjh81.png?v=1765788004"
      }
    ],
    "url": "https://lelafine.de/products/sun-halskaede-925-solvbelagt",
    "builder": true,
    "category": "halskaeder",
    "variantId": "49057720336726",
    "sku": "H-155-SH-925S",
    "available": true
  },
  {
    "id": "melted-heart-g",
    "handle": "melted-hjerte-perle-stud",
    "productId": "9514511565142",
    "name": "Herz Perlen Ohrringe vergoldet",
    "metal": "gold",
    "family": "melted-heart",
    "variant": "",
    "price": 59.95,
    "description": "Herzförmige Ohrringe mit Süßwasserperlen.",
    "material": "Vergoldet",
    "size": "Ca. 24 × 5 mm · ein Paar",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eesreplicate-prediction-j8dd7nycchrme0cv3jys6azm2r1_1.png?v=1765733501",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/smeltet_hjerte_perle.jpg?v=1765715336",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/DSC7143-kopi_1.jpg?v=1765733654",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_1422.jpg?v=1765733654"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eesreplicate-prediction-j8dd7nycchrme0cv3jys6azm2r1_1.png?v=1765733501",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eesreplicate-prediction-j8dd7nycchrme0cv3jys6azm2r1_1.png?v=1765733501"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/smeltet_hjerte_perle.jpg?v=1765715336",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/smeltet_hjerte_perle.jpg?v=1765715336"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/DSC7143-kopi_1.jpg?v=1765733654",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/DSC7143-kopi_1.jpg?v=1765733654"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_1422.jpg?v=1765733654",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_1422.jpg?v=1765733654"
      }
    ],
    "url": "https://lelafine.de/products/melted-hjerte-perle-stud",
    "builder": true,
    "category": "oreringe",
    "variantId": "50029299269974",
    "sku": "O-147-HEH-18KG",
    "available": true
  },
  {
    "id": "atlantic-g",
    "handle": "atlantic-ferskvandsperlehalskaede",
    "productId": "9551759343958",
    "name": "Atlantic Halskette",
    "metal": "gold",
    "family": "atlantic",
    "variant": "",
    "price": 59.95,
    "description": "",
    "material": "Vergoldet",
    "size": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/esesfggimage1.png?v=1782473902",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Atlantic_Ferskvandsperlehalsk_de.png?v=1750149118",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eeo42141eefeimage15.png?v=1782473769"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/esesfggimage1.png?v=1782473902",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/esesfggimage1.png?v=1782473902"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Atlantic_Ferskvandsperlehalsk_de.png?v=1750149118",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Atlantic_Ferskvandsperlehalsk_de.png?v=1750149118"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eeo42141eefeimage15.png?v=1782473769",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/eeo42141eefeimage15.png?v=1782473769"
      }
    ],
    "url": "https://lelafine.de/products/atlantic-ferskvandsperlehalskaede",
    "builder": true,
    "category": "halskaeder",
    "variantId": "50160349675862",
    "sku": "H-158-SE-18KG",
    "available": true
  },
  {
    "id": "classic10-g",
    "handle": "classic-hoop-10-mm",
    "productId": "9605622858070",
    "name": "Classic Hoop 10 mm vergoldet",
    "metal": "gold",
    "family": "classic10",
    "variant": "",
    "price": 22.95,
    "description": "Klassische, glatte Creolen mit 10 mm Innendurchmesser.",
    "material": "Vergoldet",
    "size": "10 mm Innendurchmesser",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classic-41_1.png?v=1770985286",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group309.jpg?v=1772018200",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_0865_Stor.jpg?v=1770985272",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classic-41_1.png?v=1770985286",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classic-41_1.png?v=1770985286"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group309.jpg?v=1772018200",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group309.jpg?v=1772018200"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_0865_Stor.jpg?v=1770985272",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_0865_Stor.jpg?v=1770985272"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/guldhoopbundlesmindre_4cf019af-e270-4a35-bdec-9b7b3bc574a5.gif?v=1771628555"
      }
    ],
    "url": "https://lelafine.de/products/classic-hoop-10-mm",
    "builder": true,
    "category": "oreringe",
    "variantId": "50384891674966",
    "sku": "O-201-SW-18KG",
    "available": true
  },
  {
    "id": "snake-bracelet-s",
    "handle": "flad-slange-armband-solvbelagt",
    "productId": "9687074996566",
    "name": "Flaches Schlangenarmband 4mm versilbert",
    "metal": "silver",
    "family": "snake-bracelet",
    "variant": "15 cm",
    "price": 37.95,
    "description": "",
    "material": "Versilbert",
    "size": "15 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame290_1.png?v=1753879468",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/banglebillede2_d1aa414e-5a6b-4273-9c29-6a527200964e.png?v=1755024180",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8619Stor.jpg?v=1755024180",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_85952Stor.jpg?v=1755024180"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame290_1.png?v=1753879468",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame290_1.png?v=1753879468"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/banglebillede2_d1aa414e-5a6b-4273-9c29-6a527200964e.png?v=1755024180",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/banglebillede2_d1aa414e-5a6b-4273-9c29-6a527200964e.png?v=1755024180"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8619Stor.jpg?v=1755024180",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8619Stor.jpg?v=1755024180"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_85952Stor.jpg?v=1755024180",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_85952Stor.jpg?v=1755024180"
      }
    ],
    "url": "https://lelafine.de/products/flad-slange-armband-solvbelagt",
    "builder": true,
    "category": "armband",
    "variantId": "50720339263830",
    "sku": "A-128-FS-925S",
    "available": true,
    "variants": [
      {
        "id": "snake-bracelet-s-15cm",
        "name": "15 cm",
        "size": "15 cm",
        "variantId": "50720339263830",
        "sku": "A-128-FS-925S",
        "variant": "15 cm",
        "price": 37.95,
        "available": true
      },
      {
        "id": "snake-bracelet-s-18cm",
        "name": "18 cm",
        "size": "18 cm",
        "variantId": "55044676550998",
        "sku": "A-128-FS-925S-18cm",
        "variant": "18 cm",
        "price": 37.95,
        "available": true
      }
    ]
  },
  {
    "id": "classic10-s",
    "handle": "classic-hoop-10-mm-solvbelagt",
    "productId": "9810733826390",
    "name": "Classic Hoop 10 mm Silberfarben",
    "metal": "silver",
    "family": "classic10",
    "variant": "",
    "price": 29.95,
    "description": "Klassische, glatte Creolen mit 10 mm Innendurchmesser.",
    "material": "Silberfarbener Edelstahl",
    "size": "10 mm Innendurchmesser",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classichoop10mmguldbelagt_7c3e15f4-cbac-4367-b7e0-ee909ead8e2c_1.png?v=1757511689",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2824_1.jpg?v=1757944604"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classichoop10mmguldbelagt_7c3e15f4-cbac-4367-b7e0-ee909ead8e2c_1.png?v=1757511689",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/classichoop10mmguldbelagt_7c3e15f4-cbac-4367-b7e0-ee909ead8e2c_1.png?v=1757511689"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2824_1.jpg?v=1757944604",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_2824_1.jpg?v=1757944604"
      }
    ],
    "url": "https://lelafine.de/products/classic-hoop-10-mm-solvbelagt",
    "builder": true,
    "category": "oreringe",
    "variantId": "51275699880278",
    "sku": "O-256-CH-925S",
    "available": true
  },
  {
    "id": "blue-heart-s",
    "handle": "blaat-hjerte-stud-solvbelagt",
    "productId": "9630388879702",
    "name": "Blaues Herz-Stecker versilbert",
    "metal": "silver",
    "family": "blue-heart",
    "variant": "",
    "price": 55.95,
    "description": "Herzförmige Ohrstecker. Ca. 15 × 9 mm.",
    "material": "Versilbert",
    "size": "Ca. 15 × 9 mm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/oceanheartstudoreringsolvbelagt.png?v=1750145737",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/blaasoelvoerering.png?v=1753976025",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_5204_jpg_5a6f8dcf-2062-4e7d-83af-1900ea5e1693.jpg?v=1753976025",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_1022.jpg?v=1761572455",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_5199_jpg_34fcb6b3-c601-4786-88b5-62a60a3c221f.jpg?v=1761572455",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/klara1IMG_514521.png?v=1761572455"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/oceanheartstudoreringsolvbelagt.png?v=1750145737",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/oceanheartstudoreringsolvbelagt.png?v=1750145737"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/blaasoelvoerering.png?v=1753976025",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/blaasoelvoerering.png?v=1753976025"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_5204_jpg_5a6f8dcf-2062-4e7d-83af-1900ea5e1693.jpg?v=1753976025",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_5204_jpg_5a6f8dcf-2062-4e7d-83af-1900ea5e1693.jpg?v=1753976025"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_1022.jpg?v=1761572455",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_1022.jpg?v=1761572455"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_5199_jpg_34fcb6b3-c601-4786-88b5-62a60a3c221f.jpg?v=1761572455",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_5199_jpg_34fcb6b3-c601-4786-88b5-62a60a3c221f.jpg?v=1761572455"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/klara1IMG_514521.png?v=1761572455",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/klara1IMG_514521.png?v=1761572455"
      }
    ],
    "url": "https://lelafine.de/products/blaat-hjerte-stud-solvbelagt",
    "builder": true,
    "category": "oreringe",
    "variantId": "50482444599638",
    "sku": "O-111-KC-925S",
    "available": true
  },
  {
    "id": "hammered-g",
    "handle": "hamret-bangle-armband-18k-guldbelagt",
    "productId": "9107798327638",
    "name": "Gehämmerter Armreif",
    "metal": "gold",
    "family": "hammered",
    "variant": "Default Title",
    "price": 52.95,
    "description": "Ein goldfarbener Armreif mit gehämmerter Oberfläche.",
    "material": "Vergoldet",
    "size": "Ein Schmuckstück",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Hamret_Bangle_Armb_nd_Guldbelagt.webp?v=1750146278",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/bangleimage000041_a59b25cb-a068-4ea5-b25a-0ae9b657805b.png?v=1770193910",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/model_01_cropped.jpg?v=1757172303",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8290_75fcdce3-391d-412f-9841-3b9587c67cee.jpg?v=1767711453",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_4403.jpg?v=1769762271"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Hamret_Bangle_Armb_nd_Guldbelagt.webp?v=1750146278",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Hamret_Bangle_Armb_nd_Guldbelagt.webp?v=1750146278"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/bangleimage000041_a59b25cb-a068-4ea5-b25a-0ae9b657805b.png?v=1770193910",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/bangleimage000041_a59b25cb-a068-4ea5-b25a-0ae9b657805b.png?v=1770193910"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/model_01_cropped.jpg?v=1757172303",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/model_01_cropped.jpg?v=1757172303"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/31a1f09338834e09aab692357ef5fdd9/31a1f09338834e09aab692357ef5fdd9.HD-720p-4.5Mbps-66461853.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/31a1f09338834e09aab692357ef5fdd9.thumbnail.0000000000.jpg?v=1767711434"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8290_75fcdce3-391d-412f-9841-3b9587c67cee.jpg?v=1767711453",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8290_75fcdce3-391d-412f-9841-3b9587c67cee.jpg?v=1767711453"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_4403.jpg?v=1769762271",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_4403.jpg?v=1769762271"
      },
      {
        "type": "video",
        "src": "https://cdn.shopify.com/videos/c/vp/1b032751457341d59d20eb74484230ef/1b032751457341d59d20eb74484230ef.HD-720p-1.6Mbps-36904049.mp4",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/preview_images/1b032751457341d59d20eb74484230ef.thumbnail.0000000000.jpg?v=1729689142"
      }
    ],
    "url": "https://lelafine.de/products/hamret-bangle-armband-18k-guldbelagt",
    "builder": true,
    "category": "armband",
    "variantId": "48649099379030",
    "sku": "A-105-HB-18KG",
    "available": true
  },
  {
    "id": "classic-dot-g",
    "handle": "classic-krystal-dot-armband-guldbelagt",
    "productId": "9764684693846",
    "name": "Klassisches Kristall Punkt Armband vergoldet",
    "metal": "gold",
    "family": "classic-dot",
    "variant": "",
    "price": 55.95,
    "referencePrice": 55.95,
    "description": "",
    "material": "Vergoldet",
    "size": "53 × 64 mm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_02_guld.jpg?v=1764248898",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/NYT.dot2-mindreblaa2.png?v=1767452262",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group583.png?v=1767452262",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Crystaldotekstra2.png?v=1767186464",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Linestjernering1_1_3c7261e6-3b15-427c-9aa8-3047ece7ba13.png?v=1767186464"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_02_guld.jpg?v=1764248898",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_02_guld.jpg?v=1764248898"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/NYT.dot2-mindreblaa2.png?v=1767452262",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/NYT.dot2-mindreblaa2.png?v=1767452262"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group583.png?v=1767452262",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group583.png?v=1767452262"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Crystaldotekstra2.png?v=1767186464",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Crystaldotekstra2.png?v=1767186464"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Linestjernering1_1_3c7261e6-3b15-427c-9aa8-3047ece7ba13.png?v=1767186464",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Linestjernering1_1_3c7261e6-3b15-427c-9aa8-3047ece7ba13.png?v=1767186464"
      }
    ],
    "url": "https://lelafine.de/products/classic-krystal-dot-armband-guldbelagt",
    "builder": true,
    "category": "armband",
    "variantId": "51081420636502",
    "sku": "A-130-KB-18KG",
    "available": true
  },
  {
    "id": "classic-dot-s",
    "handle": "classic-krystal-dot-armband-solvbelagt",
    "productId": "10013920854358",
    "name": "Classic Krystal Dot Armband versilbert",
    "metal": "silver",
    "family": "classic-dot",
    "variant": "",
    "price": 55.95,
    "referencePrice": 55.95,
    "description": "",
    "material": "Versilbert",
    "size": "53 × 64 mm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_02_soelv.jpg?v=1766065402",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/tmp4cbs7u32.png?v=1766065402",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/tmpusp0e6n0.png?v=1766065402",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group583.png?v=1767452262"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_02_soelv.jpg?v=1766065402",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/packshot_02_soelv.jpg?v=1766065402"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/tmp4cbs7u32.png?v=1766065402",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/tmp4cbs7u32.png?v=1766065402"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/tmpusp0e6n0.png?v=1766065402",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/tmpusp0e6n0.png?v=1766065402"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group583.png?v=1767452262",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Group583.png?v=1767452262"
      }
    ],
    "url": "https://lelafine.de/products/classic-krystal-dot-armband-solvbelagt",
    "builder": true,
    "category": "armband",
    "variantId": "52005223792982",
    "sku": "A-131-KB-925S",
    "available": true
  },
  {
    "id": "rope-bracelet-g",
    "handle": "snoet-rope-armband-18k-guldbelagt",
    "productId": "9107921895766",
    "name": "Gedrehtes Rope Armband vergoldet",
    "metal": "gold",
    "family": "rope-bracelet",
    "variant": "",
    "price": 37.95,
    "referencePrice": 37.95,
    "description": "",
    "material": "Vergoldet",
    "size": "15 cm + 4 cm",
    "images": [
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame288_1.png?v=1753877935",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ropeogpaperv1.jpg?v=1763199947",
      "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8550.jpg?v=1755676006"
    ],
    "media": [
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame288_1.png?v=1753877935",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/Frame288_1.png?v=1753877935"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ropeogpaperv1.jpg?v=1763199947",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/ropeogpaperv1.jpg?v=1763199947"
      },
      {
        "type": "image",
        "src": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8550.jpg?v=1755676006",
        "poster": "https://cdn.shopify.com/s/files/1/0843/0885/3078/files/IMG_8550.jpg?v=1755676006"
      }
    ],
    "url": "https://lelafine.de/products/snoet-rope-armband-18k-guldbelagt",
    "builder": true,
    "category": "armband",
    "variantId": "48649396191574",
    "sku": "A-106-SR-18KG",
    "available": true,
    "needsSize": true,
    "variants": [
      {
        "id": "rope-bracelet-g-15cm",
        "name": "15 cm",
        "size": "15 cm + 4 cm",
        "variantId": "48649396191574",
        "sku": "A-106-SR-18KG",
        "variant": "15 cm",
        "price": 37.95,
        "referencePrice": 37.95,
        "available": true
      },
      {
        "id": "rope-bracelet-g-18cm",
        "name": "18 cm",
        "size": "18 cm + 4 cm",
        "variantId": "55596188533078",
        "sku": "A-106-SR-18KG-18cm",
        "variant": "18 cm",
        "price": 37.95,
        "referencePrice": 37.95,
        "available": true
      }
    ]
  }
];
